import { DeepPartial, AppConfig } from "../../../../src/app/interfaces/app-config";

export const projectConfig: DeepPartial<AppConfig> = {
  // Ejemplo
  pages: {
    login: {
      title: 'Iniciar sesión',
    },
    profile: {
      titlePlural: 'Registros',
      titleSingular: 'Registro',
      form_filter: {
        name:{
          label: 'Nombre',
          placeholder: 'Escribir nombre'
        },
        lastName:{
          label: 'Apellido',
          placeholder: 'Escribir apellido'
        },
        email:{
          label: 'Correo electrónico',
          placeholder: 'Escribir correo electrónico'
        },
        numberCi:{
          label: 'Numero de carnet',
          placeholder: 'Escribir numero carnet'
        },
        initial_date:{
          label: 'Fecha inicio',
          placeholder: 'Escribir...'
        },
        end_date:{
          label: 'Fecha fin',
          placeholder: 'Escribir...'
        },
        city:{
          label: 'Ciudad',
          placeholder: 'Escribir...'
        },
        event:{
          label: 'Eventos',
          placeholder: 'Seleccionar...'
        },
      }
    },
    accounts: {
      addAccountBtn: 'Agregar nueva cuenta de socio'
    }
  },

  menu: [
    {
      headTitle1: "General",
      permissions: 'default',
    },
    {
      id: 1,
      level: 1,
      path: '/my-accounts',
      title: "Mis Cuentas",
      icon: "home",
      type: "link",
      permissions: 'default',
    },
    {
      id: 2,
      level: 1,
      path: '/payment-history',
      title: "Historial de pagos",
      icon: "bookmark",
      type: "link",
      permissions:'default',
    },
    {
      id: 3,
      level: 1,
      path: '/payment-cards',
      title: "Mis tarjetas almacenadas",
      icon: "bookmark",
      type: "link",
      permissions:'default',
    },
  ],
  horizontalMenu: [],
  authGoogle: true,
  completeProcessPlugin: true,
};
